var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page !== 'start')?_c('div',{staticClass:"ly_header"},[_c('a',{staticClass:"el_exitBtn",attrs:{"href":"#"},on:{"click":function($event){_vm.openExit()}}},[_vm._v("おわる")]),_vm._v(" "),(_vm.exit)?_c('Exit',{on:{"close":function($event){_vm.closeExit()}}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d3f16ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Header.vue
// module id = null
// module chunks = 